import moment from 'moment'
import React from 'react'
import { Button, Card, Col, Drawer, Form, Icon, notification, Row, Table, Select, Upload, Tabs } from 'antd'
import _ from 'lodash'

import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import Request, { API_URL, LAPI_URL } from '../../request'
import { connect } from 'react-redux'
const Option = Select.Option

@Form.create()
class AddAttendence extends React.Component {
    state = {
        visible: true,
        childrenDrawer: true,
        adId: '',
        leads: [],
        file: '',
        arr: [],
        ext: null,
        linkUrl: null,
        loading: false,
        excelFieldArray: [],
        excelDatas: [],
        paymentUpload: [],
        DBFieldsArray: [
            "studentName", 'status', "mode", "selectInquiryType", "dateOfBirth", "gender", "mobile", "watsupp", "emailId", "facebookEmail", "whichYearPlanningToGo", "enqType", "location", "caseHistory", "preference"
        ],
        fieldMappingArray: {},
        statusList: '',
        coursedata: '',
        oldUniversityId: '',
        inputTypes: {
            fields: [
                {
                    label: 'Select User',
                    key: 'userId',
                    type: 'select',
                    showSearch: true,
                    options: [],
                    required: true,
                    onChange: v => {
                        this.props.form.setFieldsValue({ userId: v })
                    }
                },
                {
                    label: 'Attendance Date',
                    key: 'attendanceDate',
                    type: 'date',
                    required: true,
                },
                {
                    label: 'Start Time',
                    key: 'loginAt',
                    type: 'time',
                    format: 'HH:MM:SS',
                    required: true,
                },
                {
                    label: 'End Time',
                    key: 'logoutAt',
                    type: 'time',
                    required: true,
                },
                {
                    label: 'Reason',
                    key: 'updateReason',
                    type: 'text',
                    required: true,
                }
            ]
        }
    }


    componentDidMount() {
        let { allUsers, userId } = this.props
        let inputTypes = this.state.inputTypes;
        inputTypes.fields[0].options = allUsers;
        this.setState({ inputTypes }, () => {
            if (userId) {
                this.props.form.setFieldsValue({ userId: userId })
            }
        })
    }

    onClose = () => {
        this.setState({
            visible: false
        })

        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    handleSubmit = e => {
        e.preventDefault();
        const { form, courseId, oldAttendence } = this.props;
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData);
                let x = await Request.updateAttendence(values)
                if (!x.error) {
                    this.onClose()
                    notification.success({
                        message: 'Success',
                        description: x.msg
                    })
                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: x.msg
                    })
                }
            }

        })
    }

    render() {

        const {
            form: { getFieldDecorator, getFieldValue }
        } = this.props
        const { visible, inputTypes } = this.state
        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Add Attendance
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={800}
                visible={visible}>
                <Card>
                    <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                        <div>
                            <GetAllFormFields
                                apiurl={LAPI_URL}
                                inputSchema={inputTypes}
                                getFieldDecorator={getFieldDecorator}
                            />
                        </div>
                        <Row style={{ marginTop: '20px' }}>
                            <Col span={8} />
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.props.loading}>
                                    Save
                                </Button>
                            </Col>
                            <Col span={8} />
                        </Row>
                    </Form>
                </Card>
            </Drawer>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddAttendence)
